import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { DataSharingService } from '../../services/data-sharing.service';
import { DownloadService } from '../../services/download.service';
import { publicMethods } from '../../globals';
declare var $: any;

@Component({
  selector: 'downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.css'],
  standalone: false,
})
export class DownloadsComponent implements OnInit, OnChanges {
  companyIds: Array<any> = [];
  searchParams: HttpParams = null;
  downloadUrl: string;
  downloadRequestId: string;

  userDownloadUsage: number;
  userDownloadLimit: number;
  userRemainingDownloads: number;
  selectedCompanyCount: number = 0;
  userDownloadFormat = [];
  // TODO: some of this is already known from companyIds/searchParams subscriptions and could be merged
  @Input() inputParams: Record<string, any> = {}; // {'totalCompaniesSelected': totalCompaniesSelected, 'totalCompanyCount': companyCount.count, 'hasSelectedTotalNumberMatchingFilter': hasSelectedTotalNumberMatchingFilter}

  @Output() downloadDataFetched = new EventEmitter<boolean>();

  constructor(
    private downloadService: DownloadService,
    private data: DataSharingService,
    public pubMethods: publicMethods
  ) {}

  isLoading = this.downloadService.isLoading;

  ngOnInit() {
    $('#downloadModal').on('hide.bs.modal', () => {
      this.downloadUrl = null;
      this.downloadRequestId = null;
    });
    this.data.currentSelectedCompanyIds.subscribe(
      companyIds => (this.companyIds = companyIds)
    );
    this.data.currentSelectedSearchParams.subscribe(
      searchParams => (this.searchParams = searchParams)
    );

    this.downloadService.getDownloadUsage().subscribe(data => {
      if (this.pubMethods.hasData(data)) {
        this.userDownloadUsage = data.downloads_this_period || 0;
        this.userDownloadLimit = data.total_download_limit;
        this.userRemainingDownloads =
          this.userDownloadLimit - this.userDownloadUsage;
        this.parseDownloadFormat(data.user_download_format);
      }
      this.downloadDataFetched.emit(true);
    });
  }

  parseDownloadFormat(rawUserDownloadFormat): void {
    this.userDownloadFormat = rawUserDownloadFormat
      ?.map(el => {
        try {
          return JSON.parse(el);
        } catch (err) {
          return el;
        }
      })
      .filter(Boolean);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.inputParams.currentValue.hasSelectedTotalNumberMatchingFilter) {
      this.selectedCompanyCount =
        changes.inputParams.currentValue.totalCompanyCount;
    } else {
      this.selectedCompanyCount =
        changes.inputParams.currentValue.totalCompaniesSelected;
    }
  }

  processDownloadLink(output): void {
    if (output.download_url) {
      this.downloadUrl = output.download_url;
      window.open(this.downloadUrl);
    } else if (output.download_request_id) {
      this.downloadRequestId = output.download_request_id;
    }
  }

  generateCSVDownloadUrl(): void {
    this.downloadUrl = null;
    this.downloadRequestId = null;
    this.downloadService
      .downloadCompanies(this.companyIds, this.searchParams)
      .subscribe(output => this.processDownloadLink(output));
  }
}
